import React, { FC, useState, useEffect, useCallback, useMemo } from 'react';
import { FlexBox, useToasts } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { API, TagsAPI } from '@brg/api';
import {
  MainTitle
} from '../sendProjects/styles';
import { ModalClose } from 'core/modules/modal.module';
import { CloseModalIcon } from 'core/modules/CloseIconNew';
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { AppTester } from 'supporting';
import { BTag } from 'core/components/bTag/bTag';
import { SearchIcon } from 'shared/icons';
import {
  CanonicalDomainModalWrapper,
  CanonicalDomainModalContainer,
  ScrollableDomainsContainer,
  SelectedDomainsWrapper,
  SelectedDomainsTitle,
  SelectedDomainsContainer,
  DomainsContainer,
  LoadingContainer,
  DomainsGrid
} from './CanonicalDomainModal.styles';
import { TagsSearchInputWrapper, TagsSearchInput } from '../selectTagsModal/styles';

interface IPlatform {
  id: string;
  appName: string;
  context: string;
  url: string;
  entityTypes?: string[];
  entityTypesEduTags?: string[];
  entityTypesRequiredTags?: string[];
}

interface ContextModalProps {
  selectedContexts: { appName: string; context: string; url: string }[];
  usedContexts: string[];
  availableContexts: IPlatform[];
  onSave: (contexts: { appName: string; context: string; url: string }[]) => void;
  onClose: () => void;
}

export const ContextModal: FC<ContextModalProps> = ({
  selectedContexts,
  usedContexts,
  availableContexts: availableContextsProp,
  onSave,
  onClose
}) => {
  const { t } = useTranslation();
  const toasts = useToasts();
  const theme = useTheme();
  const isGeo = AppTester.isGeograffee();

  const [searchQuery, setSearchQuery] = useState('');
  const [selectedContextsState, setSelectedContextsState] = useState<IPlatform[]>([]);

  useEffect(() => {
    if (selectedContexts && selectedContexts.length > 0) {
      const initialSelectedContexts = selectedContexts.map(context => {
        const foundContext = availableContextsProp.find(platform => 
          platform.appName === context.appName && platform.context === context.context
        );
        return foundContext || {
          id: `${context.appName}_${context.context}`,
          appName: context.appName,
          context: context.context,
          url: context.url
        };
      }).filter(Boolean);
      
      setSelectedContextsState(initialSelectedContexts);
    } else {
      setSelectedContextsState([]);
    }
  }, [selectedContexts, availableContextsProp]);


  const filteredContexts = useMemo(() => {
    return availableContextsProp.filter(platform => {
      const isAllTags = platform.appName === 'alltags' && platform.context === 'hsedesign';
      if (isAllTags) {
        return false;
      }
      
      const matchesSearch = platform.url.toLowerCase().includes(searchQuery.toLowerCase());
      
      const contextValue = `${platform.appName}:${platform.context}`;
      const isUsed = usedContexts.includes(contextValue);
      
      const isAlreadySelected = selectedContextsState.some(selected => 
        selected.appName === platform.appName && selected.context === platform.context
      );
      
      return matchesSearch && !isUsed && !isAlreadySelected;
    });
  }, [availableContextsProp, searchQuery, selectedContextsState, usedContexts]);

  const addContext = (platform: IPlatform) => {
    if (!selectedContextsState.find(p => p.id === platform.id)) {
      setSelectedContextsState(prev => [...prev, platform]);
    }
  };

  const removeContext = (platformId: string) => {
    setSelectedContextsState(prev => prev.filter(p => p.id !== platformId));
  };

  const handleSave = () => {
    const contextsData = selectedContextsState.map(platform => ({
      appName: platform.appName,
      context: platform.context,
      url: platform.url
    }));
    onSave(contextsData);
    onClose();
  };

  return (
    <CanonicalDomainModalWrapper>
      <CanonicalDomainModalContainer>
        <FlexBox width="100%" direction="column">
          <FlexBox justify='space-between' offsetBottom={32}>
            <MainTitle>{t('tags_modal.context_modal.title')}</MainTitle>
            <SendProjectButton isGreen={isGeo} width={187} onClick={handleSave}>
              {t('competition.save')}
            </SendProjectButton>
          </FlexBox>

          <ModalClose onClick={onClose}>
            <CloseModalIcon />
          </ModalClose>

          <TagsSearchInputWrapper gx={12} offsetBottom={16}>
            <SearchIcon fill={theme.tags.modal.search.color}/>
            <TagsSearchInput
              value={searchQuery}
              onChange={(e: any) => setSearchQuery(e.target.value)}
              placeholder="Поиск по контекстам"
            />
          </TagsSearchInputWrapper>

          {selectedContextsState.length > 0 && (
            <SelectedDomainsWrapper>
              <SelectedDomainsTitle>
                {t('tags_modal.canonical_domain.selected_contexts')}
              </SelectedDomainsTitle>
              <SelectedDomainsContainer>
                {selectedContextsState.map((platform) => (
                  <BTag
                    key={platform.id}
                    removable
                    showRemoveIcon
                    onIconClick={() => removeContext(platform.id)}
                  >
                    {platform.url}
                  </BTag>
                ))}
              </SelectedDomainsContainer>
            </SelectedDomainsWrapper>
          )}

          <DomainsContainer>
            <ScrollableDomainsContainer>
              <DomainsGrid>
                {filteredContexts.map((platform) => (
                  <BTag
                    key={platform.id}
                    removable
                    selected={selectedContextsState.find(p => p.id === platform.id) !== undefined}
                    onClick={() => addContext(platform)}
                  >
                    {platform.url}
                  </BTag>
                ))}
              </DomainsGrid>
            </ScrollableDomainsContainer>
          </DomainsContainer>
        </FlexBox>
      </CanonicalDomainModalContainer>
    </CanonicalDomainModalWrapper>
  );
};
import React, { FC, useState, useEffect, useCallback, useMemo } from 'react';
import { FlexBox, useToasts } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { API, TagsAPI } from '@brg/api';
import {
  MainTitle
} from '../sendProjects/styles';
import { ModalClose } from 'core/modules/modal.module';
import { CloseModalIcon } from 'core/modules/CloseIconNew';
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { AppTester } from 'supporting';
import { BTag } from 'core/components/bTag/bTag';
import { SearchIcon } from 'shared/icons';
import {
  CanonicalDomainModalWrapper,
  CanonicalDomainModalContainer,
  ScrollableDomainsContainer,
  SelectedDomainsWrapper,
  SelectedDomainsTitle,
  SelectedDomainsContainer,
  DomainsContainer,
  LoadingContainer,
  DomainsGrid
} from './CanonicalDomainModal.styles';
import { TagsSearchInputWrapper, TagsSearchInput } from '../selectTagsModal/styles';

interface IPlatform {
  id: string;
  appName: string;
  context: string;
  url: string;
  entityTypes?: string[];
  entityTypesEduTags?: string[];
  entityTypesRequiredTags?: string[];
}

interface ContextModalProps {
  selectedContexts: { appName: string; context: string; url: string }[];
  usedContexts: string[];
  availableContexts: IPlatform[];
  onSave: (contexts: { appName: string; context: string; url: string }[]) => void;
  onClose: () => void;
}

export const ContextModal: FC<ContextModalProps> = ({
  selectedContexts,
  usedContexts,
  availableContexts: availableContextsProp,
  onSave,
  onClose
}) => {
  const { t } = useTranslation();
  const toasts = useToasts();
  const theme = useTheme();
  const isGeo = AppTester.isGeograffee();

  const [searchQuery, setSearchQuery] = useState('');
  const [selectedContextsState, setSelectedContextsState] = useState<IPlatform[]>([]);

  useEffect(() => {
    if (selectedContexts && selectedContexts.length > 0) {
      const initialSelectedContexts = selectedContexts.map(context => {
        const foundContext = availableContextsProp.find(platform => 
          platform.appName === context.appName && platform.context === context.context
        );
        return foundContext || {
          id: `${context.appName}_${context.context}`,
          appName: context.appName,
          context: context.context,
          url: context.url
        };
      }).filter(Boolean);
      
      setSelectedContextsState(initialSelectedContexts);
    } else {
      setSelectedContextsState([]);
    }
  }, [selectedContexts, availableContextsProp]);


  const filteredContexts = useMemo(() => {
    return availableContextsProp.filter(platform => {
      const isAllTags = platform.appName === 'alltags' && platform.context === 'hsedesign';
      if (isAllTags) {
        return false;
      }
      
      const matchesSearch = platform.url.toLowerCase().includes(searchQuery.toLowerCase());
      
      const contextValue = `${platform.appName}:${platform.context}`;
      const isUsed = usedContexts.includes(contextValue);
      
      const isAlreadySelected = selectedContextsState.some(selected => 
        selected.appName === platform.appName && selected.context === platform.context
      );
      
      return matchesSearch && !isUsed && !isAlreadySelected;
    });
  }, [availableContextsProp, searchQuery, selectedContextsState, usedContexts]);

  const addContext = (platform: IPlatform) => {
    if (!selectedContextsState.find(p => p.id === platform.id)) {
      setSelectedContextsState(prev => [...prev, platform]);
    }
  };

  const removeContext = (platformId: string) => {
    setSelectedContextsState(prev => prev.filter(p => p.id !== platformId));
  };

  const handleSave = () => {
    const contextsData = selectedContextsState.map(platform => ({
      appName: platform.appName,
      context: platform.context,
      url: platform.url
    }));
    onSave(contextsData);
    onClose();
  };

  return (
    <CanonicalDomainModalWrapper>
      <CanonicalDomainModalContainer>
        <FlexBox width="100%" direction="column">
          <FlexBox justify='space-between' offsetBottom={32}>
            <MainTitle>{t('tags_modal.context_modal.title')}</MainTitle>
            <SendProjectButton isGreen={isGeo} width={187} onClick={handleSave}>
              {t('competition.save')}
            </SendProjectButton>
          </FlexBox>

          <ModalClose onClick={onClose}>
            <CloseModalIcon />
          </ModalClose>

          <TagsSearchInputWrapper gx={12} offsetBottom={16}>
            <SearchIcon fill={theme.tags.modal.search.color}/>
            <TagsSearchInput
              value={searchQuery}
              onChange={(e: any) => setSearchQuery(e.target.value)}
              placeholder="Поиск по контекстам"
            />
          </TagsSearchInputWrapper>

          {selectedContextsState.length > 0 && (
            <SelectedDomainsWrapper>
              <SelectedDomainsTitle>
                {t('tags_modal.canonical_domain.selected_contexts')}
              </SelectedDomainsTitle>
              <SelectedDomainsContainer>
                {selectedContextsState.map((platform) => (
                  <BTag
                    key={platform.id}
                    removable
                    showRemoveIcon
                    onIconClick={() => removeContext(platform.id)}
                  >
                    {platform.url}
                  </BTag>
                ))}
              </SelectedDomainsContainer>
            </SelectedDomainsWrapper>
          )}

          <DomainsContainer>
            <ScrollableDomainsContainer>
              <DomainsGrid>
                {filteredContexts.map((platform) => (
                  <BTag
                    key={platform.id}
                    removable
                    selected={selectedContextsState.find(p => p.id === platform.id) !== undefined}
                    onClick={() => addContext(platform)}
                  >
                    {platform.url}
                  </BTag>
                ))}
              </DomainsGrid>
            </ScrollableDomainsContainer>
          </DomainsContainer>
        </FlexBox>
      </CanonicalDomainModalContainer>
    </CanonicalDomainModalWrapper>
  );
};
